module.exports = __webpack_public_path__ + "img/08影音.eaca21bf.jpg";